import { Field, Form, Formik } from 'formik';
import React, { useMemo } from 'react';
import { Dashboard, DashboardBackButton, PageLayout } from '@components';
import { Button, ButtonClean, Fieldset, HeadContent, Input, Subsection, Tag, } from '@fourthwall/components';
import { routing } from '@utils/routing';
import logoSrc from '../../assets/signets/meta-capi.svg';
import { ConnectBar } from '../../components/ConnectBar/ConnectBar';
import { ConnectValidationSchema } from './consts';
import { useMetaConversionPixel } from './hooks/useMetaConversionPixel';
export const AppsMetaConversions = () => {
    const { pixelId, updatePixel, deletePixel } = useMetaConversionPixel();
    const isConnected = useMemo(() => !!pixelId, [pixelId]);
    const renderStatusTag = () => {
        const props = isConnected
            ? {
                label: 'Connected',
                appearance: 'success',
            }
            : {
                label: 'Not Connected',
                appearance: 'alert',
            };
        return (React.createElement("div", { style: { marginBottom: 20 } },
            React.createElement(Tag, { ...props, size: "large", display: "inline-flex" })));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(HeadContent, { title: "Meta Ads" }),
        React.createElement(PageLayout, { size: "tiny" },
            React.createElement(Dashboard.Section, { name: "Meta Ads", topContent: React.createElement(DashboardBackButton, { label: "Apps", to: routing.apps.self }) },
                React.createElement(Subsection, null,
                    renderStatusTag(),
                    React.createElement("div", null,
                        "Send conversion events to Meta's Ads Manager if you run paid ad campaigns for your shop.",
                        ' ',
                        React.createElement(ButtonClean, { href: routing.external.helpCenter.metaCAPI, label: "Learn more", target: "_blank" }))),
                !isConnected && (React.createElement(Subsection, { title: "Connection" },
                    React.createElement(Formik, { initialValues: {}, validationSchema: ConnectValidationSchema, onSubmit: ({ pixelId, accessToken }) => updatePixel({ pixelId: pixelId, accessToken: accessToken }) }, ({ isSubmitting }) => (React.createElement(Form, null,
                        React.createElement("div", { style: { marginBottom: 16 } },
                            "Use your Conversions API Pixel ID and Access Token from your Meta Events Manager dashboard.",
                            ' ',
                            React.createElement(ButtonClean, { href: routing.external.helpCenter.metaCAPI, label: "Where can I find this?", target: "_blank" })),
                        React.createElement(Fieldset, null,
                            React.createElement(Fieldset.Row, null,
                                React.createElement(Fieldset.Item, null,
                                    React.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: 16 } },
                                        React.createElement(Field, { component: Input, name: "pixelId", label: "Pixel ID" }),
                                        React.createElement(Field, { component: Input, name: "accessToken", label: "Access Token", type: "password" }))))),
                        React.createElement("div", { style: { marginTop: 16 } },
                            React.createElement(Button, { type: "submit", label: "Add Conversions API Pixel", appearance: "primary", loading: isSubmitting }))))))),
                isConnected && (React.createElement(Subsection, { title: "Connection" },
                    React.createElement("div", { style: { marginBottom: 16 } },
                        React.createElement("p", { style: { marginBottom: 16 } },
                            React.createElement(ConnectBar, { logoSrc: logoSrc, description: `Pixel ${pixelId}`, tag: null, onDisconnect: () => deletePixel() })))))))));
};
